<div class="wrapper">
  <span class="header left">{{ "CLAIMS_LIST.HEADER.INDEX" | translate }}</span>
  <span class="header right">{{ "CLAIMS_LIST.HEADER.DUE_DATE" | translate }}</span>
  <span class="header right">{{ "CLAIMS_LIST.HEADER.AMOUNT" | translate }}</span>
  <mat-divider></mat-divider>
  @for (claim of caseData.claims; track $index; let i = $index) {
    <span class="data left">
      <span>{{ "CLAIMS_LIST.INDEX" | translate: { index: i + 1 } }}</span>
      @if (claim.file) {
        <a
          target="_blank"
          style="margin-left: 15px"
          [href]="claim.file.storage_url"
        >
          {{ claim.file.file_name }}
        </a>
      }
    </span>
    <span class="data right">{{ claim.expired_at | date: "yyyy.MM.dd." }}</span>
    <span class="data right">{{ claim.remaining_amount | number: "1.0" : "hu" }} {{ claim.currency }}</span>
  }
</div>
